import React, { useState, useEffect } from "react";
import { useStoreon } from "storeon/react";
import { useHistory } from "react-router-dom";
import themeStyles from "../../shared/styles/theme/theme-styles.module.scss";
import styles from "./styles.module.scss";
import TextEditor from "../components/textEditor/textEditor";
import CardLaneScore from "../components/cardLaneScore/cardLaneScore";
import {
  SAVE_SETTINGS_CARD,
  LOAD_SETTINGS_CARD,
} from "../../store/scoreCardSettings";
import { LOAD_GENERAL_SETTINGS } from "../../store/generalSettings";
import BackgroundColor from "../components/backgroungColor/backgroundColor";
import CardByLane from "../components/cardByLane/cardByLane";
import img from "../../shared/images/settings-background.jpg";
import SETUP_TYPES from "shared/utils/constants/setupTypes";

const playersPreview = [
  {
    activePlayer: false,
    active_player: false,
    game: 1,
    lane: 1,
    playerHcp: 0,
    playerName: "Player 1",
    playerNumber: 1,
    scoreCompletedGames: 0,
    teamHcp: 0,
    teamName: "",
    pins: [],
    scores: [18],
    speed: [],
    throws: ["6", "/", "X"],
  },
  {
    activePlayer: false,
    active_player: false,
    game: 1,
    lane: 2,
    playerHcp: 0,
    playerName: "Player 2",
    playerNumber: 2,
    scoreCompletedGames: 0,
    teamHcp: 0,
    teamName: "",
    pins: [],
    scores: [18],
    speed: [],
    throws: ["6", "/"],
  },
];

const ScoreCardSettings = () => {
  const history = useHistory();
  const { dispatch, scoreCardSettings, auth, setupType } = useStoreon(
    "scoreCardSettings",
    "setupType",
  );

  const [cardStyles, setCardStyles] = useState(
    setupType === SETUP_TYPES.LANE
      ? scoreCardSettings[0].settings
      : scoreCardSettings[1].settings,
  );

  useEffect(() => {
    dispatch(LOAD_GENERAL_SETTINGS, { history });
    dispatch(LOAD_SETTINGS_CARD, { history });
  }, [auth, dispatch]);

  useEffect(() => {
    const type = setupType === SETUP_TYPES.LANE ? 1 : 2;
    const res = scoreCardSettings.find((e) => e.type === type)?.settings;
    setCardStyles(res);
  }, [setupType, scoreCardSettings]);

  const onChangeColor = (typeKey) => (color) => {
    const [type, key] = typeKey.split(".");
    setCardStyles({
      ...cardStyles,
      [type]: key ? { ...cardStyles[type], [key]: color.hex } : color.hex,
    });
  };

  const onChangeFontSize = (type) => (e) => {
    setCardStyles({
      ...cardStyles,
      [type]: { ...cardStyles[type], fontSize: e.target.value },
    });
  };

  const onChangeFontWeight = (type) => (e) => {
    setCardStyles({
      ...cardStyles,
      [type]: { ...cardStyles[type], fontBold: e ? true : false },
    });
  };

  const onSave = () => {
    try {
      dispatch(SAVE_SETTINGS_CARD, {
        data: {
          settings: cardStyles,
          type: setupType === SETUP_TYPES.LANE ? 1 : 2,
        },
        history,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles.overallContainer}>
      <div className={styles.lines}></div>

      <div className={styles.bodyContainer}>
        <div className={styles.containerSettings}>
          <div className={styles.playerSettings}>
            <div className={styles.bodySettings}>
              <div className={styles.backgroundInputContainer}>
                <span>Section Container Background</span>
                <div className={styles.backgroundInput}>
                  <BackgroundColor
                    handleChange={onChangeColor("sectionContainerBackground")}
                    background={cardStyles.sectionContainerBackground}
                    skew
                  />
                </div>
              </div>

              <div className={styles.backgroundInputContainer}>
                <span>Frames Container Background</span>
                <div className={styles.backgroundInput}>
                  <BackgroundColor
                    handleChange={onChangeColor("framesContainerBackground")}
                    background={cardStyles.framesContainerBackground}
                    skew
                  />
                </div>
              </div>

              <div className={styles.backgroundInputContainer}>
                <span>Scores Container Background</span>
                <div className={styles.backgroundInput}>
                  <BackgroundColor
                    handleChange={onChangeColor("scoresContainerBackground")}
                    background={cardStyles.scoresContainerBackground}
                    skew
                  />
                </div>
              </div>
              <div className={styles.backgroundInputContainer}>
                <span>
                  {setupType === SETUP_TYPES.LANE
                    ? "Top Frame Background"
                    : "Inner Background"}
                </span>
                <div className={styles.backgroundInput}>
                  <BackgroundColor
                    handleChange={onChangeColor(
                      setupType === SETUP_TYPES.LANE
                        ? "topFrameBackground"
                        : "innerBackground",
                    )}
                    background={
                      cardStyles[
                        setupType === SETUP_TYPES.LANE
                          ? "topFrameBackground"
                          : "innerBackground"
                      ]
                    }
                    skew
                  />
                </div>
              </div>

              <div className={styles.backgroundInputContainer}>
                <span>Low Current Frame Background</span>
                <div className={styles.backgroundInput}>
                  <BackgroundColor
                    handleChange={onChangeColor(
                      "currentFrame.lowFrameBackground",
                    )}
                    background={cardStyles.currentFrame?.lowFrameBackground}
                    skew
                  />
                </div>
              </div>
              <div className={styles.backgroundInputContainer}>
                <span>Top Current Frame Background</span>
                <div className={styles.backgroundInput}>
                  <BackgroundColor
                    handleChange={onChangeColor(
                      "currentFrame.topFrameBackground",
                    )}
                    background={cardStyles.currentFrame?.topFrameBackground}
                    skew
                  />
                </div>
              </div>
            </div>
            <div className={styles.bodySettings}>
              <TextEditor
                playerNameStyles={cardStyles.playerName}
                handleChangeComplete={onChangeColor("playerName.fontColor")}
                handleChangeBackground={onChangeColor("playerName.background")}
                handleOnSelect={onChangeFontSize("playerName")}
                selectBold={onChangeFontWeight("playerName")}
                stylesLabel="Player Name Styles"
                fontWeight
              />
              <TextEditor
                playerNameStyles={cardStyles.throwsStyle}
                handleChangeComplete={onChangeColor("throwsStyle.fontColor")}
                handleChangeBackground={onChangeColor("throwsStyle.background")}
                handleOnSelect={onChangeFontSize("throwsStyle")}
                selectBold={onChangeFontWeight("throwsStyle")}
                stylesLabel="Throws"
                text="Throws"
                fontWeight
              />
              <TextEditor
                playerNameStyles={cardStyles.frameScore}
                handleChangeComplete={onChangeColor("frameScore.fontColor")}
                handleChangeBackground={onChangeColor("frameScore.background")}
                handleOnSelect={onChangeFontSize("frameScore")}
                selectBold={onChangeFontWeight("frameScore")}
                stylesLabel="Throws Score"
                text="18"
                fontWeight
              />

              {setupType === SETUP_TYPES.LANE && (
                <TextEditor
                  playerNameStyles={cardStyles.frameScore}
                  handleChangeComplete={onChangeColor("frameScore.fontColor")}
                  handleChangeBackground={onChangeColor(
                    "frameScore.background",
                  )}
                  handleOnSelect={onChangeFontSize("frameScore")}
                  selectBold={onChangeFontWeight("frameScore")}
                  stylesLabel={`"Frame Score" Styles`}
                  text={"Scores"}
                  fontWeight
                />
              )}
              {setupType === SETUP_TYPES.PLAYER && (
                <>
                  <TextEditor
                    playerNameStyles={cardStyles.totalScore}
                    handleChangeComplete={onChangeColor("totalScore.fontColor")}
                    handleChangeBackground={onChangeColor(
                      "totalScore.background",
                    )}
                    handleOnSelect={onChangeFontSize("totalScore")}
                    selectBold={onChangeFontWeight("totalScore")}
                    stylesLabel={`"Total Score" Styles`}
                    text={"Total Scores"}
                    fontWeight
                  />
                  <TextEditor
                    playerNameStyles={cardStyles.bowlingcenter}
                    handleChangeComplete={onChangeColor(
                      "bowlingcenter.fontColor",
                    )}
                    handleChangeBackground={onChangeColor(
                      "bowlingcenter.background",
                    )}
                    handleOnSelect={onChangeFontSize("bowlingcenter")}
                    selectBold={onChangeFontWeight("bowlingcenter")}
                    stylesLabel={`Bowling Center Name Styles`}
                    text={"Bowling Center Name"}
                    fontWeight
                  />
                </>
              )}
              
            </div>
          </div>
          <div className={styles.playerSettings}>
            <div className={styles.bodySettings}>
              {setupType === SETUP_TYPES.LANE && (
                <CardByLane
                  playersPreview={playersPreview}
                  cardStyles={cardStyles}
                />
              )}
              {setupType === SETUP_TYPES.PLAYER && (
                <CardLaneScore
                  playersPreview={playersPreview}
                  cardStyles={cardStyles}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.bodyContainer}>
        <div style={{ padding: "0 20px 60px" }}>
          <button
            className={themeStyles.btnPrimaryLT}
            onClick={onSave}
            style={{ width: "100%", maxWidth: "306px" }}
          >
            Save
          </button>
        </div>
      </div>
      <div
        className={styles.backgroundImage}
        style={{
          backgroundImage: `url(${img})`,
        }}
      ></div>
    </div>
  );
};
export default ScoreCardSettings;
